import { render, staticRenderFns } from "./SettingListView.vue?vue&type=template&id=8a26f054&scoped=true"
import script from "./SettingListView.vue?vue&type=script&lang=js"
export * from "./SettingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a26f054",
  null
  
)

export default component.exports